/**
 * Selected Text Modal
* Created On: 01-01-2025
 */
import React from 'react';
import PropTypes from 'prop-types';

//  Motif controls
import MotifModal, { MotifModalHeader, MotifModalBody, MotifModalFooter } from '@ey-xd/motif-react/Modal';

import './SelectedText.scss';

import iconWarning from "../../../../assets/images/warning.svg";
import { MotifButton } from '@ey-xd/motif-react';

import { discard_popup_header,discard_popup_body,replace_popup_header,replace_popup_body } from '../../../../assets/data/constants';

const SelectedText = ({
    selectedTextModalShow,
    isDiscardClicked,
    setSelectedTextModalShow,
    selectedTextConfirm
}) => {

    return (
        <MotifModal
                        id="selectedTextModal"
                        show={selectedTextModalShow}
                        onClose={() => setSelectedTextModalShow(!selectedTextModalShow)}
                        size="sm"
                        className="confirmModal"
                        focusTrapOptions={{
                            tabbableOptions: {
                              displayCheck: "none",
                            },
                          }}
                    >
                    <MotifModalHeader className="selectedTextHeader"
                        closeButtonProps={{
                            'aria-label': 'Close',
                            title: 'Close',
                            className: 'selectedTextCloseButton'
                        }}
                        
                    >
                        <img src={iconWarning} alt="Warning icon" />
                        <div className="selectedTextTitle">{isDiscardClicked?discard_popup_header:replace_popup_header}</div>
                    </MotifModalHeader>
                    <MotifModalBody className="selectedTextModalBody">
                        <span className="selectedTextModalContent">
                        {isDiscardClicked?
                        discard_popup_body:
                        replace_popup_body}
                        </span>
                    </MotifModalBody>
                    <MotifModalFooter className="selectedTextModalFooter">
                        <MotifButton
                            label="btnCancel"
                            size="small"
                            type="button"
                            variant="secondary"
                            className="btnCancel"
                            onClick={() => setSelectedTextModalShow(!selectedTextModalShow)}
                        >
                            Cancel
                        </MotifButton>
                        <MotifButton
                            label="btnConfirm"
                            size="small"
                            type="button"
                            variant="primary"
                            className="btnConfirm"
                            onClick={() => selectedTextConfirm()}
                        >
                            Confirm
                        </MotifButton>
                    </MotifModalFooter>

                    </MotifModal>
        
    );
};

SelectedText.propTypes = {
    selectedTextModalShow: PropTypes.bool,
    isDiscardClicked:PropTypes.bool,
    setSelectedTextModalShow: PropTypes.func,
    selectedTextConfirm: PropTypes.func
};

export default SelectedText;